module.exports = __webpack_public_path__ + "img/ico_xianshiyouxuan.37cc8e3b.png";